import { Button, Tab, Tabs, Typography } from '@material-ui/core';
import { useGenericStyles } from 'common/genericStyles';
import { AdicionarExtratoRequest, GrupoAcesso, InvestidorResponse, Perfil } from 'common/genericTypes';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import { DatePicker, LgSpace, SmSpace } from 'm2m.components';
import React, {useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { InvestidorDocumentos } from './documentos';
import { InvestidorInformacoesPrincipais } from './informacoesPrincipais';
import { InvestidorRepresentantesLegais } from './representantesLegais';
import { addAlert } from 'store/modules/snackBar';
import moment, { Moment } from 'moment';

interface Props {
    investidor: InvestidorResponse | null;
}

const DetalhesInvestidor: React.FC<Props> = (props) => {
  const classes = useGenericStyles();
  const [tabValue, setTabValue] = useState<number>(0);
  const investidor = props.investidor;
  const [dataInicio, setDataInicio] = useState<Moment | null>();
  const [dataFim, setDataFim] = useState<Moment | null>();

  const dispatch = useDispatch();
  const downloadExtrato = useSelector((state: RootState) => state.investidorApi.postExtratos);
  const isUsuarioOperacoes = useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Operacoes;
  const isParticipanteCustodiante = useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Comum;
  const usuarioLogado = useSelector((state: RootState) => state.auth.usuario);

  const handleDownload = async () => {
    try {
      if (isUsuarioOperacoes || isParticipanteCustodiante) {
        const params: AdicionarExtratoRequest = {
            CpfCnpjInvestidor: investidor?.cpfCnpj || '',
            CpfCnpjSolicitante: usuarioLogado.participante.cnpj,
            NomeInvestidor: investidor?.razaoSocial || '',
            NomeSolicitante: usuarioLogado.participante.razaoSocial,
            DataInicio: dataInicio,
            DataFim: dataFim
        };

        const extrato = await downloadExtrato(dispatch, params, true);
        const address = extrato.address;
        window.open(address, '_blank');
      } else {
        dispatch(addAlert({ severity: 'error', message: 'Falha ao realizar download do extrato' }));
      }
    } catch (error) {
      dispatch(addAlert({ severity: 'error', message: 'Falha ao realizar download do extrato' }));
      console.log(error);
    }
  }

  return (
    <div>
    <div style={{ display: 'flex', alignItems: 'center' }}>

      <fieldset style={{padding: '20px 40px', width: '50%'}}>
      <legend><Typography className={classes.wrapTxt} variant="h3">{`Investidor ${investidor?.razaoSocial || ''}`}</Typography></legend>
        <DatePicker
            label='Data Inicio'
            value={dataInicio}
            style={{ width: 300, paddingRight: 20 }}
            onChange={(value) => setDataInicio(value)}
            />
        <DatePicker
            label='Data Fim'
            value={dataFim}
            style={{ width: 300 }}
            onChange={(value) => setDataFim(value)}
            />

        <Button
        variant={'contained'}
        color="primary"
        size="medium"
        style={{ marginLeft: 20 }}
        onClick={handleDownload}
        >
        {'Baixar Extrato'}
        </Button>
      </fieldset>
    </div>

    <SmSpace/>
        <HorizontalAppBar>
        <Tabs indicatorColor="primary" value={tabValue} onChange={(_event, newTab) => setTabValue(newTab)}>
          <Tab label="Informações Principais" />
        </Tabs>
        </HorizontalAppBar>
        {tabValue === 0 && investidor && <InvestidorInformacoesPrincipais investidor={investidor} />}
        {tabValue === 1 && investidor && (
            <InvestidorRepresentantesLegais representantesLegais={investidor.representantesLegais} />
        )}
        {tabValue === 2 && investidor && <InvestidorDocumentos investidor={investidor} />}
        <LgSpace />
    </div>
  );
};

export default DetalhesInvestidor;
